import { gql } from '@apollo/client'

export default gql(`
    mutation batchUpdateUserGroups($userInput: [CreateUserInput] $project: String) {
        batchUpdateUserGroups(
            input: $userInput
            project: $project
        ){
            id
            accessRoleGroups {
              id
              name
              modules{
                name
                permissions
              }
            }
        }
    }
`)
